import sanitizeHTML from 'sanitize-html'

export const downloadFile = (url: string, name?: string) => {
  if (url.indexOf('.pdf') > -1) {
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/pdf',
      },
    }).then((response) => {
      response.blob().then((blob) => {
        const fileURL = window.URL.createObjectURL(blob)
        openInNewTab(fileURL, true, name)
      })
    })
  } else {
    openInNewTab(url, true, name)
  }
}

export const openInNewTab = (url: string, needDownload?: boolean, name?: string) => {
  if (!url) {
    return
  }
  const alink = document.createElement('a')
  alink.href = sanitizeHTML(url)
  alink.target = '_blank'
  alink.rel = 'noopener noreferrer'
  if (needDownload) {
    alink.download = name || 'document'
  }
  alink.click()
  if (alink && alink.parentNode) {
    alink.parentNode.removeChild(alink)
  }
}
